"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildEntityAndFile = void 0;

var types_1 = require("../types");

var Hashing_1 = require("./Hashing");
/**
 * Take all the entity's data, build the entity file with it, and calculate its id
 */


function buildEntityAndFile(_x) {
  return _buildEntityAndFile.apply(this, arguments);
}

function _buildEntityAndFile() {
  _buildEntityAndFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var version, type, pointers, timestamp, content, metadata, entity, entityFile, entityId, entityWithId;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            version = _ref.version, type = _ref.type, pointers = _ref.pointers, timestamp = _ref.timestamp, content = _ref.content, metadata = _ref.metadata;

            if (!(pointers.length === 0)) {
              _context.next = 3;
              break;
            }

            throw new Error("All entities must have at least one pointer.");

          case 3:
            if (!(version === types_1.EntityVersion.V2)) {
              _context.next = 5;
              break;
            }

            throw new Error("V2 is not supported.");

          case 5:
            entity = {
              version: version,
              type: type,
              pointers: pointers,
              timestamp: timestamp,
              content: content,
              metadata: metadata
            };
            entityFile = Buffer.from(JSON.stringify(entity));

            if (!(version === types_1.EntityVersion.V3)) {
              _context.next = 13;
              break;
            }

            _context.next = 10;
            return Hashing_1.Hashing.calculateBufferHash(entityFile);

          case 10:
            _context.t0 = _context.sent;
            _context.next = 16;
            break;

          case 13:
            _context.next = 15;
            return Hashing_1.Hashing.calculateIPFSHash(entityFile);

          case 15:
            _context.t0 = _context.sent;

          case 16:
            entityId = _context.t0;
            entityWithId = _objectSpread({
              id: entityId
            }, entity);
            return _context.abrupt("return", {
              entity: entityWithId,
              entityFile: entityFile
            });

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _buildEntityAndFile.apply(this, arguments);
}

exports.buildEntityAndFile = buildEntityAndFile;